import { useState, useEffect } from 'react'
import SearchField from 'react-search-field';
import ContentModel from './ContentModel'
import AddContentModel from './AddContentModel'

const ContentModels = ({language, setBreadcrumbObject}) => {
    const [contentModels, setContentModels] = useState([])
    const [contentModelList, setContentModelList] = useState([])
    const [addContentModelShow, setAddContentModelShow] = useState(false)


    const handleAddContentModelShow = async e => {
        e.preventDefault();
        setAddContentModelShow(addContentModelShow ? false : true)
    }
    useEffect(() => {
        setContentModelList(contentModels)
      },[contentModels])

    useEffect(() => {
          
        const getData = async () => {
            const data = await fetchData()
            
            setContentModels(data.contentModels)
            setBreadcrumbObject({type: '', name:language.value === "DA" ? "Indholds modeller " : "Content models", link: '', linkText: ''})
          }
      
          getData()
      },[language])

      const fetchData = async () => {

        var graphql = JSON.stringify({
            query: `query {
                        contentModels{
                            id
                            modelName
                            modelIcon
                            modelType
                        }
                    }`,
            variables: { }
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {return JSON.parse(result).data})
        .catch(error => console.log('error', error))
        const data = await res
        console.log('data', data)
        return data
    }

    const searchContentModels = (keyword) => {
        setContentModelList(
            contentModels.filter((contentModel) => 
                (contentModel.modelName.toLowerCase().includes(keyword.toLowerCase()))
            )
        )
    }

    return (
        <>
        <div id="cc_article_list_filter" className="cc_list_filter">
            <div className="filter-block">
                <span>
                    {language.value === 'DA' ? 'Søg efter indholds modeller' : 'Search for content models'}
                </span>
                <SearchField classNames="searchInput" onChange={searchContentModels} placeholder={language.value === 'DA' ? 'Søger i indholds modeller' : 'Search in content models'} />
            </div>
            <div className="filter-block">
                <span>&nbsp;</span>
                <div className="btn-group">
                    <button onClick={handleAddContentModelShow} className="cc-btn blue-gradient">{language.value === 'DA' ? 'Tilføj ny model' : 'Add new model'}</button>
                </div>
            </div>
        </div>
        <div id="cc_article_list" className="cc_item_list">
            <label className="list-header">
                <span className="checkbox-container">&nbsp;</span>
                <span className="name-container">{language.value === 'DA' ? 'Modelnavn' : 'Model name'}</span>
                <span className="type-container">{language.value === 'DA' ? 'Modeltype' : 'Model type'}</span>
                <span className="published-container">{language.value === 'DA' ? 'Egenskab' : 'Property'}</span>
                <span className="edit-container">
                    &nbsp;
                </span>
            </label>
            {contentModelList.map((contentModel) => (
                <ContentModel 
                    key={contentModel.id}
                    language={language} 
                    contentModel={contentModel} 
                />
            ))}
        </div>
        {(addContentModelShow) && <AddContentModel language={language}
                                                isVisible={addContentModelShow}
                                                setIsVisible={setAddContentModelShow}/>}
        </>
    )
}

export default ContentModels
